import { resolveCustomerContact } from "@/modules/common/utils/customer-contact";
import { useQuery } from "@tanstack/react-query";
import { getCustomerByUId } from "../api";

export const useCustomer = ({ uid }: { uid?: string }) => {
  const query = useQuery({
    queryKey: ["customers", uid],
    queryFn: () => getCustomerByUId({ uid }),
    enabled: !!uid,
    staleTime: 1000 * 60 * 5,
    select: (data) => {
      if (!data || !data.data) {
        return undefined; // If no data, return undefined
      }

      const { data: customer } = data;

      const active = customer.leads?.some((lead) => {
        if (!lead.validityTime) {
          return false; // If no validity time, consider it inactive
        }

        const validityDate = new Date(lead.validityTime);

        if (isNaN(validityDate.getTime())) {
          return false; // If the date is invalid, consider it active
        }

        const currentDate = new Date();

        return validityDate >= currentDate; // Check if the lead is still valid
      });

      const telephone =
        resolveCustomerContact(customer.telephones, customer.doNotCall).phone ??
        null;

      const email =
        customer.emails?.find((em) => em.default)?.email ??
        customer.emails?.[0]?.email ??
        null;

      const result = {
        ...customer,
        active,
        telephone,
        email,
      };
      return result;
    },
  });

  return query;
};
